import React, { useEffect, useState } from "react";
import "./navbar.css";

const Navbar = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("user");
    if (stored) {
      setUser(JSON.parse(stored));
    }
  }, []);

  return (
    <nav className="main-navbar">

      {/* LEFT SIDE – USER NAME / EMAIL */}
      <div className="nav-left">
        <h2 className="username">
          Hello, {user?.name || user?.email || "User"}
        </h2>
        {/* <p style={{ fontSize: "14px", color: "#aaa" }}>
          {user?.email}
        </p> */}
      </div>

      {/* RIGHT SIDE – PROFILE PICTURE */}
      <div className="nav-right">
        <img
          src={user?.photo || "https://i.pravatar.cc/40"}
          alt="profile"
          className="profile-pic"
        />
      </div>

    </nav>
  );
};

export default Navbar;
